import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    item: {
      backgroundColor: theme.primary700,
      borderRadius: 4,
      color: theme.white50,
      fontSize: 12,
      padding: theme.spacing(2, 4),
    },
  }),
);
type Props = {
  children: React.ReactNode;
  className?: string;
  "data-test-id"?: string;
};
export function IndexItem({
  children,
  className = "",
  "data-test-id": dataTestId,
}: Props) {
  const classes = useStyles();

  return (
    <div className={`${classes.item} ${className}`} data-test-id={dataTestId}>
      {children}
    </div>
  );
}
